<div class="text" [class.align-left]="textAlign" [innerHTML]="currentText | safe_html"></div>
<a *ngIf="text.length > maxLength" class="read-more" (click)="toggleView()">Read {{isCollapsed? 'more':'less'}}</a>